import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './AdminDashboard.css';
import AdminUserManagement from './AdminUserManagement';
import AdminJobList from './AdminJobList';
import AdminCollegeList from './AdminCollegeList';
import AdminCustomerApproval from './AdminCustomerApproval';
import AdminActivityLogs from './AdminActivityLogs'; // <--- [NEW] Imported Activity Logs

// Pulling directly from the Recruiter module!
import MasterApplicants from '../Recruiter/JobPosting/MasterApplicants';

import {
  ShieldCheck,
  Users,
  GraduationCap,
  Briefcase,
  LogOut,
  ChevronRight,
  PanelLeftClose,
  PanelLeftOpen,
  Inbox,
  Activity // <--- [NEW] Added Activity Icon
} from 'lucide-react';

const AdminDashboard = () => {
  const [activeTab, setActiveTab] = useState('User Management');
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    if (!token) {
      navigate('/');
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.clear();
    navigate('/');
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'User Management':    return <AdminUserManagement />;
      case 'Consolidated Jobs':  return <AdminJobList />;
      case 'College Management': return <AdminCollegeList />;
      case 'Customer Approvals': return <AdminCustomerApproval />; 
      case 'Master Inbox':       return <MasterApplicants posterRole="Admin" />;      
      case 'Activity Logs':      return <AdminActivityLogs />; // <--- [NEW] Added Switch Case
      default:                   return <AdminUserManagement />;
    }
  };

  const navItems = [
    { label: 'User Management',   icon: <Users size={18} /> },
    { label: 'College Management', icon: <GraduationCap size={18} /> },
    { label: 'Consolidated Jobs',  icon: <Briefcase size={18} /> },
    { label: 'Master Inbox',       icon: <Inbox size={18} /> }, 
    { label: 'Activity Logs',      icon: <Activity size={18} /> }, // <--- [NEW] Added to Sidebar
  ];

  return (
    <div className="admin-dashboard">

      {/* ── LEFT SIDEBAR ── */}
      <aside className={`admin-sidebar ${collapsed ? 'admin-sidebar--collapsed' : ''}`}>
        <div className="admin-brand">
          <div className="admin-brand-icon"><ShieldCheck size={20} /></div>
          {!collapsed && (
            <div className="admin-brand-text">
              <div className="admin-brand-title">Admin Panel</div>
              <div className="admin-brand-subtitle">Hotel Placement</div>
            </div>
          )}
          <button className="admin-collapse-btn" onClick={() => setCollapsed(!collapsed)}>
            {collapsed ? <PanelLeftOpen size={17} /> : <PanelLeftClose size={17} />}
          </button>
        </div>

        {!collapsed && <div className="admin-nav-label">Navigation</div>}

        <nav className="admin-nav">
          {navItems.map(({ label, icon }) => (
            <button
              key={label}
              type="button"
              className={`admin-nav-item ${activeTab === label ? 'active' : ''}`}
              onClick={() => setActiveTab(label)}
            >
              <span className="admin-nav-icon">{icon}</span>
              {!collapsed && (
                <>
                  <span className="admin-nav-text">{label}</span>
                  <span className="admin-nav-arrow"><ChevronRight size={15} /></span>
                </>
              )}
            </button>
          ))}
        </nav>

        <div className="admin-sidebar-footer">
          <button type="button" className="admin-logout" onClick={handleLogout}>
            <LogOut size={18} />
            {!collapsed && <span>Log Out</span>}
          </button>
        </div>
      </aside>

      {/* ── RIGHT CONTENT ── */}
      <main className="admin-content">
        <div className="admin-content-inner">
          {renderContent()}
        </div>
      </main>

    </div>
  );
};

export default AdminDashboard;